export default __webpack_public_path__ + "static/media/Throw Action_Illustration.fe5e8350.png";